import React, { Component } from 'react';

import { connect } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import capitalize from 'capitalize';

import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import FooterButtons from 'components/shared/FooterButtons';
import { startsWith } from 'helpers/StringHelper';

import * as landlordAPIDashboard from 'actions/landlordAPIDashboardActions';

const style = {
  table_header: {
    margin: '30px 0px 10px 0px',
    backgroundColor: '#f1f1f1',
  },
};

let AssetsForm = reduxForm({
  form: 'api_assets',
})(
  class AssestForm extends Component {
    UNSAFE_componentWillMount = () => {
      this.setState({ hasImage: false });
    };

    updateImage = (values) => {
      // updating to old image after removal or multiselect update
      if (values === 'removed') {
        values = this.props.formValues.values.logo_name;
        this.setState({ hasImage: false });
      } else if (Array.isArray(values) && values.length > 0) {
        this.setState({ hasImage: true });
      } else {
        this.setState({ hasImage: false });
      }

      this.props.logos.forEach((logo) => {
        if (values && logo && values.label === logo.label) {
          this.props.updateImage(logo.image);
        }
      });
    };

    render() {
      const { handleSubmit, logos } = this.props;

      return (
        <div>
          <div className="container" style={{ maxWidth: '600px', padding: '0px' }}>
            <form onSubmit={handleSubmit}>
              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-sm-6 col-sm-offset-3">
                  <Field
                    name="logo_name"
                    component={MultiSelectExtended}
                    data={logos}
                    hintText="Logo Name"
                    onChange={this.updateImage}
                  />
                </div>
              </div>

              <div className="row" style={{ marginTop: '15px' }}>
                <div className="col-sm-6 col-sm-offset-3">
                  <Field
                    name="logo_image"
                    component={ReduxDropzone}
                    fileChanged={this.updateImage}
                    fileValidation="image/*"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      );
    }
  }
);

export default connect(
  (store) => {
    return {
      logos: store.landlordAPIDashboard.logos,
      formValues: store.form.api_assets,
    };
  },
  (dispatch) => {
    return {
      updateImage: (value) => {
        dispatch(change('api_assets', 'logo_image', value));
      },
      postLogo: (mode, name, image) => {
        return dispatch(landlordAPIDashboard.postLogo(mode, name, image));
      },
      putLogo: (mode, id, image) => {
        return dispatch(landlordAPIDashboard.putLogo(mode, id, image));
      },
      clearLogos: (mode) => {
        dispatch(landlordAPIDashboard.displayLogos({ logos: null }));
      },
    };
  }
)(
  class Settings extends Component {
    constructor(props) {
      super(props);

      this.state = {
        mode: 'test',
      };
    }

    UNSAFE_componentWillMount() {
      const query = browserHistory.getCurrentLocation().query;
      if (!this.props.logos || !query.mode) {
        browserHistory.push('/companies/api_dashboard_settings');
      }

      this.setState({ mode: query.mode });
    }

    onSubmit = (data) => {
      const {
        logo_name: { value, label },
        logo_image,
      } = data;
      if (startsWith(value, 'null')) {
        // values that don't have an id will have the form 'null-n'
        this.props.postLogo(this.state.mode, label, logo_image[0]).then(() => {
          browserHistory.push('/companies/api_dashboard_settings');
          this.props.clearLogos();
        });
      } else {
        this.props.putLogo(this.state.mode, value, logo_image[0]).then(() => {
          browserHistory.push('/companies/api_dashboard_settings');
          this.props.clearLogos();
        });
      }
    };

    buildLogoArray = (logos) => {
      // build default template
      const logoArray = [...Array(10).keys()].map((i) => {
        return { value: `null-${i + 1}`, label: `logo_${i + 1}`, image: null };
      });

      // merge template with real data
      return logoArray.map((templateItem) => {
        let logo = (logos || []).filter((realLogo) => realLogo.name === templateItem.label)[0];
        // logo exists in the backend
        if (logo) {
          return { value: logo.id, label: logo.name, image: logo.url };
        } else {
          return templateItem;
        }
      });
    };

    render() {
      const logos = this.buildLogoArray(this.props.logos);

      let initialValues;
      if (this.props.logos && this.props.logos.length > 0) {
        initialValues = { logo_name: logos[0], logo_image: logos[0].image };
      }

      return (
        <div className="body stage clearfix" role="main" style={{ height: 'calc(100% - 53px)' }}>
          <span className="page-title">
            <Link
              id="maintenanceHeader"
              style={{ color: 'inherit' }}
              to="companies/api_dashboard_settings"
            >
              API Settings ({capitalize(this.state.mode)})
            </Link>
            &nbsp;>&nbsp;
          </span>
          <span className="page-title"> Assets</span>
          <div className="container application-container">
            <div className="row" style={style.table_header}>
              <div style={{ padding: '5px 10px 25px 15px' }}>
                <span style={{ textAlign: 'center', float: 'left' }}>Logos</span>
              </div>
            </div>
            {
              <AssetsForm
                onSubmit={this.onSubmit}
                initialValues={initialValues}
                logos={logos}
                updateImage={this.props.updateImage}
                formValues={this.props.formValues}
              />
            }
          </div>
          <FooterButtons
            submit={this.submitForm}
            formName="api_assets"
            submitName="Save"
            backAction={() => browserHistory.goBack()}
          />
        </div>
      );
    }
  }
);
